import TemplateView from "../../../TemplateView"
import {bindActionCreators} from 'redux'
import {connect} from '../../../redux/utils'
import {afterClose, beforeOpen, changeColumnOrder, changeColumnSelection, saveChanges, setIsSummaryRowShown} from './actions'
import classicBridge from '../../../next/ClassicBridge'
import {getColumnsForConfigMenu, getIsSummaryRowShown} from './selectors'

class ConfigurationButton extends TemplateView {
    constructor({
        beforeOpen = () => {},
        afterClose = () => {},
        onPositionChanged = () => {},
        onColumnsStatusChanged = () => {},
        onIsSummaryRowShownChanged = () => {},
        onApply = () => {},
    }) {
        super()

        this.state = {
            columns: [],
            isSummaryRowShown: false,
        }

        this.actions = {
            beforeOpen,
            afterClose,
            onPositionChanged,
            onColumnsStatusChanged,
            onIsSummaryRowShownChanged,
            onApply,
        }

        this.onStatePropertyChanged('columns', (columns) => {
            this.configurator.setProps({ columns })
        })

        this.onStatePropertyChanged('isSummaryRowShown', (isSummaryRowShown) => {
            this.configurator.setProps({ isSummaryRowSelected: isSummaryRowShown })
        })
    }

    templateHtml() {
        return "<div class='atNextMount'>" +
               "</div>"
    }

    messageKeys() {
        return {
            label: "task.list.configure_columns",
        }
    }

    afterRender() {
        this.configurator = classicBridge.integrateTaskListColumnConfigurator(this.$el[0], {
            columns: this.state.columns,
            isSummaryRowShown: this.state.isSummaryRowShown,
            onSelect: this.actions.onColumnsStatusChanged,
            onSelectSummaryRow: this.actions.onIsSummaryRowShownChanged,
            onReorder: this.actions.onPositionChanged,
            onApply: this.actions.onApply,
            onShow: () => this.actions.beforeOpen(),
            onHide: () => this.actions.afterClose()
        })
    }
}
export default connect(
    state => ({
        columns: getColumnsForConfigMenu(state),
        isSummaryRowShown: getIsSummaryRowShown(state)
    }),
    dispatch => ({
        beforeOpen: bindActionCreators(beforeOpen, dispatch),
        afterClose: bindActionCreators(afterClose, dispatch),
        onApply: bindActionCreators(saveChanges, dispatch),
        onColumnsStatusChanged: bindActionCreators(changeColumnSelection, dispatch),
        onIsSummaryRowShownChanged: bindActionCreators(setIsSummaryRowShown, dispatch),
        onPositionChanged: bindActionCreators(changeColumnOrder, dispatch),
    })
)(ConfigurationButton)



// WEBPACK FOOTER //
// ./web/js/taskManagement/tasksTable/configurationMenu/ConfigurationButton.js